import React, { createContext, useEffect, useState} from 'react';



type PropertyParamsContextType =  {    
    userChainvalues: string[],
    codeNameMap: object,
    nameCodeMap: object,
    userChainLength: number,
    setUserChainvalues:(e: string[])=>void | any,
    setcodeNameMap: (e:object)=> | any,
    setnameCodeMap: (e: object)=>void,
}

type PropTypes = {
    children: React.ReactNode
};

export const PropertyParamsContext = createContext<PropertyParamsContextType>({userChainLength: 0, userChainvalues: [], nameCodeMap: {}, codeNameMap: {}, setUserChainvalues:()=>null,setcodeNameMap: ()=>null, setnameCodeMap:()=>null})


export const PropertyParamsProvider = ({children} : PropTypes) =>{
    const [userChainvalues, setUserChainvalues] = useState<string[]>([]);
    const [codeNameMap, setcodeNameMap] = useState<object>({});
    const [nameCodeMap, setnameCodeMap] = useState<object>({});
    const[userChainLength, setUserChainLength] = useState<number>(0)

    const value = {userChainLength, setUserChainLength, userChainvalues, codeNameMap, nameCodeMap, setcodeNameMap, setnameCodeMap,setUserChainvalues}


    return <PropertyParamsContext.Provider value={value}>{children}</PropertyParamsContext.Provider>
}